import React, { useState } from "react";
import { ServiceCard } from "./ServiceCard";
import { ServiceMediaCard } from "./ServiceMediaCard";
import { SectionHeading } from "../../SectionHeading";
import { services } from "../../../data/portfolio";
export function WhatIDoBest() {
  const [active, setActive] = useState(0);
  return <section id="services" aria-labelledby="services-heading" className="relative isolate bg-[#050808] px-5 py-20 md:px-8 md:py-28" data-id="element-241" data-mp="3q2xvufnc285q">
      <div className="mx-auto max-w-[1480px]" data-id="element-242" data-mp="2tfjgymxbuj9t">
        <SectionHeading index="003" label="Services, skills, abilities" titleStart="What I do" accent="best?" headingId="services-heading" body="Eight capabilities, handled end to end by one generalist: creative direction, live action capture, 3D build, animation, compositing, finishing, and delivery." data-id="element-243" data-mp="2yc9xtcgyhiwa" />

        {/* Kept above the grid so both columns begin on the same line. */}
        <p className="mt-12 hidden items-center gap-3 font-mono text-[11px] uppercase tracking-[0.18em] text-white/45 md:mt-16 lg:flex" data-id="element-244" data-mp="2emzk240rt80t">
          <span aria-hidden="true" className="dot-blink h-1.5 w-1.5 rounded-full bg-[#54f6c6]" data-id="element-245" data-mp="2keksgfcqg60t" />
          {String(services.length).padStart(2, "0")} capabilities · hover to preview
        </p>

        <div className="mt-12 grid gap-8 md:mt-16 lg:mt-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,0.66fr)] lg:items-start lg:gap-14 xl:gap-20" data-id="element-246" data-mp="2aossf5lv6koy">
          <div className="min-w-0" data-id="element-247" data-mp="25q7puzj53oxc">
            <ul className="grid gap-3" data-id="element-248" data-mp="25n3g7mmwo0za">
              {services.map((service, index) => <ServiceCard key={service.id} service={service} index={index} total={services.length} active={index === active} onActivate={setActive} data-id="element-249" data-mp="21pxndwuk3gn8" data-mpi={index} />)}
            </ul>
          </div>

          {/* Desktop companion. It flips to the hovered capability's loop. */}
          <div className="hidden min-w-0 lg:block" data-id="element-250" data-mp="3m1va63zp9gap">
            <ServiceMediaCard activeIndex={active} data-id="element-251" data-mp="1kdh88hnedzxk" />
          </div>
        </div>
      </div>
    </section>;
}